interface CopyIconProps {
  height?: string;
  width?: string;
  className?: string;
  onClick?: () => void;
}
export const CopyIcon = (props: CopyIconProps) => {
  return (
    <div className={props.className} onClick={props.onClick}>
      <svg
        width={props.width || "16"}
        height={props.height || "16"}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_5300_60132)">
          <path
            d="M3.33398 9.99479C2.71273 9.99479 2.4021 9.99479 2.15707 9.8933C1.83037 9.75797 1.5708 9.49841 1.43548 9.1717C1.33398 8.92667 1.33398 8.61605 1.33398 7.99479V3.46146C1.33398 2.71472 1.33398 2.34135 1.47931 2.05614C1.60714 1.80525 1.81111 1.60128 2.062 1.47345C2.34721 1.32812 2.72058 1.32812 3.46732 1.32812H8.00065C8.62191 1.32812 8.93253 1.32812 9.17756 1.42962C9.50427 1.56494 9.76383 1.82451 9.89916 2.15121C10.0007 2.39624 10.0007 2.70687 10.0007 3.32812M8.13398 14.6615H12.534C13.2807 14.6615 13.6541 14.6615 13.9393 14.5161C14.1902 14.3883 14.3942 14.1843 14.522 13.9334C14.6673 13.6482 14.6673 13.2749 14.6673 12.5281V8.12812C14.6673 7.38139 14.6673 7.00802 14.522 6.7228C14.3942 6.47192 14.1902 6.26795 13.9393 6.14012C13.6541 5.99479 13.2807 5.99479 12.534 5.99479H8.13398C7.38725 5.99479 7.01388 5.99479 6.72866 6.14012C6.47778 6.26795 6.27381 6.47192 6.14598 6.7228C6.00065 7.00802 6.00065 7.38139 6.00065 8.12812V12.5281C6.00065 13.2749 6.00065 13.6482 6.14598 13.9334C6.27381 14.1843 6.47778 14.3883 6.72866 14.5161C7.01388 14.6615 7.38725 14.6615 8.13398 14.6615Z"
            stroke="#0056D6"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_5300_60132">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
};
